import { useMemo, type FunctionComponent } from 'react';

import type { ISingleHistoryGame } from '../../../../../../api/fetchers/history/types';
import { L12nText } from '../../../../../text/L12nText';
import { Dice, diceImage } from '../../../gameInfo/results/megasicbac/MegaSicBacHistoryResult';

import styles from './MegaSicBacResultMessage.module.css';

export const MegaSicBacResultMessage: FunctionComponent<{ game: ISingleHistoryGame }> = ({ game }) => {
  const Result: string[] = useMemo(() => {
    const { newResultCode } = game.simulated;
    return newResultCode.match(/_+(\d+)/g)!.map((match) => match.slice(1));
  }, [game]);
  return (
    <div className={styles.resultContainer}>
      <div className={styles.resultTitle}>
        <L12nText tk="HISTORY_CORRECT_RESULT" />
      </div>
      <div className={styles.container}>
        <div className={styles.container_left}>
          <span>
            <L12nText tk="PLAYER_CAPS" />: {parseInt(Result[0]) + parseInt(Result[1])}
          </span>
        </div>
        <div className={styles.container_right}>
          <span>
            <L12nText tk="BANKER_CAPS" />: {parseInt(Result[2]) + parseInt(Result[3])}
          </span>
        </div>
        <div className={styles.leftDice}>
          <img src={diceImage[Result[0] as Dice]} alt="playerDice1" />
          <img src={diceImage[Result[1] as Dice]} alt="playerDice2" />
        </div>
        <div className={styles.rightDice}>
          <img src={diceImage[Result[2] as Dice]} alt="bankerDice1" />
          <img src={diceImage[Result[3] as Dice]} alt="bankerDice2" />
        </div>
      </div>
    </div>
  );
};
